import { useEffect, useRef } from "react";
import { syncWidgetsMetafieldFromDb } from "../helper/widgetApi";

/**
 * After install/reinstall, push DB widgets → Shopify shop metafield once per app load.
 * OAuth callback also syncs server-side; this covers edge cases where that step failed.
 */
export function useSyncCalendarMetafieldsAfterInstall(installChecked, installData) {
  const startedRef = useRef(false);

  useEffect(() => {
    if (!installChecked || !installData?.shop_info?.id || startedRef.current) return;
    startedRef.current = true;

    let cancelled = false;

    (async () => {
      try {
        await syncWidgetsMetafieldFromDb();
      } catch (e) {
        if (!cancelled) {
          console.warn("[useSyncCalendarMetafieldsAfterInstall]", e);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [installChecked, installData]);
}
